import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { DashboardService } from '../dashboard.service';
import { SelectionModel } from '@angular/cdk/collections';
import * as _ from 'lodash';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CompletedFormsService } from 'src/app/completed-forms/completed-forms.service';

export interface PeriodicElement {
	name: string;
	sortTime: string;
	sortSenders: string;
	sortForms: string;
	sortTopics: string;
	subTopics: string;
}


@Component({
  selector: 'app-restore-archived-items',
  templateUrl: './restore-archived-items.component.html',
  styleUrls: ['./restore-archived-items.component.scss']
})
export class RestoreArchivedItemsComponent implements OnInit {

  actionTypeName: string = "";
  archivedForms: any = [];
  displayedColumns = ['select', 'name', 'sortTopics', 'subTopics', 'star'];
	selection = new SelectionModel<PeriodicElement>(true, []);
  toArchive = [];
  dataFound = false;
  
  constructor(
    private _dashboardService: DashboardService,
    private _router: Router,
    private _snackBar: MatSnackBar,
    private _completedFormsService: CompletedFormsService
  ) { }

  ngOnInit() {
    this.onInit();
  }

  onInit() {
    this.actionTypeName = localStorage.getItem('actionType');
    this.archivedForms = [];
		let link = window.location.pathname.split("/");
		this._dashboardService.getArchivedForms(link[2]).subscribe((response) => {
			if (response["success"]) {
				if (response["data"] && response["data"].length > 0) {
          this.dataFound = true;
          let archivedForms = response["data"];
          archivedForms.forEach((form) => {
            form["sortTopics"] = form["sortTopics"] ? (_.isString(form["sortTopics"]) ? form["sortTopics"] : Object.values(form["sortTopics"])[0]) : '';
            form["subTopics"] = form["subTopics"] ? (_.isString(form["subTopics"]) ? form["subTopics"] : Object.values(form["subTopics"])[0]) : '';
          });
					this.archivedForms = new MatTableDataSource(archivedForms);
				} else {
          this.dataFound = false;
        }
			} else {
        this.dataFound = false;
      }
		});
  }
  isAllSelected() {
		const numSelected = this.selection.selected.length;
		let numRows = 0;
		if (this.archivedForms && this.archivedForms.data && this.archivedForms.data.length) {
			numRows = this.archivedForms.data.length;
		}
		return numSelected === numRows;
	}

	masterToggle(checked) {
    this.toArchive = [];
		if (checked) {
			// gettting table element by row ids
			if (this.archivedForms.data.length > 0) {
				this.archivedForms.data.forEach((row) => {
          this.toArchive.push(row._id);
				});
			}
		} else {
			this.toArchive = [];
		}
		this.isAllSelected() ?
			this.selection.clear() :
			this.archivedForms.data.forEach(row => this.selection.select(row));
	}

	checkboxLabel(row?: PeriodicElement): string {
		if (!row) {
			return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
		}
		return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.name + 1}`;
	}

  navToActionListPage() {
    let link = window.location.pathname.split('/');
    this._router.navigateByUrl('/dashboard/' + link[2]);
  }

  restoreArchivedForms() {
    if (this.toArchive.length === 0) {
      this.openSnackBar("Please select forms to restore");
      return;
    }
    let requestData = {
      formIds: this.toArchive
    }

    this._completedFormsService.restoreArchivedForms(requestData).subscribe((response) => {
      if (response["success"]) {
        // this.onInit();
        let link = window.location.pathname.split('/');
        this._router.navigateByUrl('/dashboard/' + link[2]);
        this.openSnackBar(response["message"]);
      }
    }, (error) => {
      console.log(error);
      this.openSnackBar("Server side error occurred");
    });
  }

  openSnackBar(message) {
		this._snackBar.open(message, "Ok", {
		  duration: 2000
		});
	}

  onChecked(row, event) {
    if (event.checked) {
      this.toArchive.push(row._id);
    } else {
      let index = this.toArchive.indexOf(row._id);
      this.toArchive.splice(index, 1);
    }
  }
}
